module.exports = __webpack_public_path__ + "static/media/logo-markel.2fbeb3a6.svg";